<template>
    <div>
        <transition name="fade" appear>
            <div v-if="!loading && !capRunning" class="page welcome-page">
                
                <section :class="{'pt-6': phoneOnly, 'pt-12': pcOnly}" class="header-section">
                    <v-container :class="{'px-0': phoneOnly}" class="pb-0">
                        <div class="d-flex flex-column flex-md-row justify-md-space-between align-center">
                            <div class="mb-md-10">
                                <h1 class="primary--text font-weight-bold" :style="`font-size: ${phoneOnly ? 3 : 4}rem!important; text-shadow: 1px 10px 5px #fff;`">انضم الآن!</h1>
                                <div class="my-4 my-md-8" :class="{'d-flex': !phoneOnly}">
                                    <v-btn large depressed color="primary" outlined class="font-weight-bold ms-md-3 mt" :to="{name: 'register'}" :block="phoneOnly" style="background: #fff!important;">
                                        <v-icon size="20" left>mdi-account-plus</v-icon>
                                        حساب جديد
                                    </v-btn>
                                    <v-btn large depressed color="primary" class="font-weight-bold ms-md-3 mt-2 mt-md-0" :to="{name: 'courses'}" :block="phoneOnly">
                                        <v-icon size="20" left>mdi-play-box-multiple</v-icon>
                                        تصفح الدورات
                                    </v-btn>
                                </div>
                            </div>
                            <div class="ps-lg-10 flex-grow-1 overflow-hidden" style="max-width: 100%;">
                                <v-img src="/img/vector.png" :max-width="phoneOnly ? '100%' : ''" contain ></v-img>
                            </div>
                        </div>

                    </v-container>
                </section>

                <section v-if="featuredCourses && featuredCourses.length" :class="{'py-6': phoneOnly, 'py-12': pcOnly}">
                    <v-container :class="{'px-0': phoneOnly}">
                        <div class="d-md-flex justify-space-between align-center mb-8 mb-lg-15">
                            <h1 class="strong-text--text">
                                <v-icon :size="pcOnly ? 45 : 36" color="strong-text">mdi-play-box-multiple-outline</v-icon>
                                الدورات التعليمية
                            </h1>
                            <template v-if="pcOnly">
                                <div class="flex-grow-1 mx-12">
                                    <v-divider></v-divider>
                                </div>
                                <div>
                                    <v-btn outlined color="primary" :to="{name: 'courses'}">
                                        <span>الانتقال إلى الدورات</span>
                                        <v-icon right>mdi-arrow-left</v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </div>
                        <div v-if="pcOnly">
                            <v-row>
                                <v-col cols="12" md="6" lg="3" v-for="(course, i) in featuredCourses" :key="course.id + '-' + i" class="px-0 px-md-2 py-2">
                                    <course-card short :course="course"> </course-card>
                                </v-col>
                            </v-row>
                        </div>
                        <v-list v-else two-line class="px-0">
                            <course-list-item v-for="(course, i) in featuredCourses" class="px-7 px-lg-4" :key="course.id + '-' + i" :course="course" />

                            <div class="my-4 mx-6">
                                <v-btn block outlined color="primary" :to="{name: 'courses'}">
                                    <span>الانتقال إلى الدورات</span>
                                    <v-icon right>mdi-arrow-left</v-icon>
                                </v-btn>
                            </div>
                        </v-list>
                    </v-container>
                </section>

                <slot name="footer" />
            </div>
        </transition>


        <app-welcome-dialog v-if="platform == 'ios'" v-model="appWelcomeDialog" />
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import AppWelcomeDialog from '@/components/default/dialogs/app-welcome'
import ESection from '@/components/default/layouts/e-section'

import CourseCard from '@/components/custom/course-card'
import CourseListItem from '@/components/custom/course-list-item'

export default {
    name: "Welcome",
    data(){
        return {
            loading: false,
        }
    },
    components: {
        ESection,
        CourseCard,
        CourseListItem,
        AppWelcomeDialog
    },
    computed: {
        ...GlobalComputed,
        welcomeData(){
            return this.$store.state.globalModule.welcomeData;
        },
        featuredCourses(){
            return this.welcomeData.featured_courses;
        }
        
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;

                this.$store.dispatch('loadWelcomeData').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    // this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    created(){
        if (this.capRunning){
            if (this.platform === 'ios'){
                this.appWelcomeDialog = true;
            }else{
                this.$router.push({name: 'login'});
            }
        }else{
            if (!this.featuredCourses || this.featuredCourses.length === 0){
                this.loadData();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.header-section{
    $transition-duration: 30s;

    background-image: url(/img/bg-pattern.png);
    background-repeat: repeat;
    background-position: center;
    background-size: 75%;
    
    animation: scrollPattern $transition-duration linear infinite;

    @media (max-width: 600px) {
        background-size: cover;
        animation-duration: 30s;
    }
}
section{
    h1{
        font-size: 2.4rem!important;
        line-height: 1.3;
        font-weight: 500;

        @media(max-width: 960px){
            font-size: 1.9rem!important;
            text-align: center;
        }
    }
}

@keyframes scrollPattern {
    from { background-position: 0 0; }
    to { background-position: 100% 0; }
}
</style>